export const RESET_TEMPLATES = 'RESET_TEMPLATES'
export const GET_ADMIN_PAGE_TEMPLATES = 'GET_ADMIN_PAGE_TEMPLATES'
export const SET_ADMIN_PAGE_TEMPLATES = 'SET_ADMIN_PAGE_TEMPLATES'
export const GET_TEAM_PAGE_TEMPLATES = 'GET_TEAM_PAGE_TEMPLATES'
export const SET_TEAM_PAGE_TEMPLATES = 'SET_TEAM_PAGE_TEMPLATES'
export const SAVE_TEMPLATE = 'SAVE_TEMPLATE'
export const SET_NEW_TEMPLATE = 'SET_NEW_TEMPLATE'
export const SET_EDITED_TEMPLATE = 'SET_EDITED_TEMPLATE'
export const TOGGLE_TEMPLATES_MODAL = 'TOGGLE_TEMPLATES_MODAL'
export const TOGGLE_TEMPLATES_SIDEBAR = 'TOGGLE_TEMPLATES_SIDEBAR'
export const TOGGLE_RESPONSE_TEMPLATES_MODAL = 'TOGGLE_RESPONSE_TEMPLATES_MODAL'
export const RESET_TEAMS = 'RESET_TEAMS'
export const GET_TEAMS = 'GET_TEAMS'
export const SET_TEAMS = 'SET_TEAMS'
export const RESET_SUBSCRIPTION = 'RESET_SUBSCRIPTION'
export const GET_ACTIVE_SUBSCRIPTION = 'GET_ACTIVE_SUBSCRIPTION'
export const SET_ACTIVE_SUBSCRIPTION = 'SET_ACTIVE_SUBSCRIPTION'
export const TOGGLE_SUBMITTING_CARD = 'TOGGLE_SUBMITTING_CARD'
export const ADD_CARD = 'ADD_CARD'
export const DELETE_CARD = 'DELETE_CARD'
export const TOGGLE_SUBMITTING_SUBSCRIPTION = 'TOGGLE_SUBMITTING_SUBSCRIPTION'
export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION'
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION'
export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION'
export const RESUME_SUBSCRIPTION = 'RESUME_SUBSCRIPTION'
export const TOGGLE_CARD_MODAL = 'TOGGLE_CARD_MODAL'
export const TOGGLE_CHECKOUT_MODAL = 'TOGGLE_CHECKOUT_MODAL'
export const TOGGLE_SUBSCRIPTION_SUCCESS = 'TOGGLE_SUBSCRIPTION_SUCCESS'
export const TOGGLE_RESUMEPLAN_MODAL = 'TOGGLE_RESUMEPLAN_MODAL'
export const TOGGLE_INVOICE_FETCHING = 'TOGGLE_INVOICE_FETCHING'
export const TOGGLE_INVOICES_MODAL = 'TOGGLE_INVOICES_MODAL'
export const FETCH_INVOICES = 'FETCH_INVOICES'
export const SET_INVOICES = 'SET_INVOICES'
export const SHOW_ONBOARDING_PLANS_POPUP = 'SHOW_ONBOARDING_PLANS_POPUP'
export const SHOW_CREATE_ITEMS_POPUP = 'SHOW_CREATE_ITEMS_POPUP'
export const TOGGLE_SETTINGS_MODAL = 'TOGGLE_SETTINGS_MODAL'
export const CHANGE_TAB = 'CHANGE_TAB'
export const RESET_CONTENT = 'RESET_CONTENT'
export const SAVE_CATEGORY = 'SAVE_CATEGORY'
export const SHOW_DELETE_CONTENT_CONFIRM = 'SHOW_DELETE_CONTENT_CONFIRM'
export const SHOW_DELETE_CATEGORY_CONFIRM = 'SHOW_DELETE_CATEGORY_CONFIRM'
export const SHOW_CONTENT_PERMISSION_MODAL = 'SHOW_CONTENT_PERMISSION_MODAL'
export const SHOW_CATEGORY_MODAL = 'SHOW_CATEGORY_MODAL'
export const SHOW_MOVE_TO_CATEGORY_MODAL = 'SHOW_MOVE_TO_CATEGORY_MODAL'
export const SHOW_GLOBAL_SEARCH_MODAL = 'SHOW_GLOBAL_SEARCH_MODAL'
export const MARK_AS_FAVORITE = 'MARK_AS_FAVORITE'
export const PIN_TO_CATEGORY = 'PIN_TO_CATEGORY'
export const CREATE_DRAFT = 'CREATE_DRAFT'
export const SAVE_CONTENT = 'SAVE_CONTENT'
export const GET_CONTENTS = 'GET_CONTENTS'
export const SET_CONTENTS = 'SET_CONTENTS'
export const GET_PRIVATE_AND_FAVORITE_CONTENT = 'GET_PRIVATE_AND_FAVORITE_CONTENT'
export const SET_PRIVATE_AND_FAVORITE_CONTENT = 'SET_PRIVATE_AND_FAVORITE_CONTENT'
export const GET_CATEGORIES = 'GET_CATEGORIES'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_SORTED_CATEGORIES = 'SET_SORTED_CATEGORIES'
export const SET_LOADING_CATEGORY_ID = 'SET_LOADING_CATEGORY_ID'
export const GET_DRAFTS = 'GET_DRAFTS'
export const SET_DRAFTS = 'SET_DRAFTS'
export const IMPORT_TRAY_CONTENT = 'IMPORT_TRAY_CONTENT'
export const GET_RECENT_VIEWED_CONTENT = 'GET_RECENT_VIEWED_CONTENT'
export const SET_RECENT_VIEWED_CONTENT = 'SET_RECENT_VIEWED_CONTENT'
export const TOGGLE_GUEST_SHARING_MODAL = 'TOGGLE_GUEST_SHARING_MODAL'
export const REFRESH_ON_SHARING = 'REFRESH_ON_SHARING'
export const RESET_COMPANY = 'RESET_COMPANY'
export const CREATE_COMPANY = 'CREATE_COMPANY'
export const GET_COMPANY = 'GET_COMPANY'
export const SET_COMPANY = 'SET_COMPANY'
export const TOGGLE_COMPANY_LOADING = 'TOGGLE_COMPANY_LOADING'
export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS'
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
export const SET_MARK_AS_READ_ON_CLICK = 'SET_MARK_AS_READ_ON_CLICK'
export const SET_MARK_ALL_AS_READ_ON_CLICK = 'SET_MARK_ALL_AS_READ_ON_CLICK'
export const GET_RECENT_ACTIVITIES = 'GET_RECENT_ACTIVITIES'
export const SET_RECENT_ACTIVITIES = 'SET_RECENT_ACTIVITIES'
export const GET_MEMBERS = 'GET_MEMBERS'
export const SET_MEMBERS = 'SET_MEMBERS'
export const SET_STRIPE_CUSTOMER = 'SET_STRIPE_CUSTOMER'
export const SET_COMPANY_STORAGE_UTILIZED = 'SET_COMPANY_STORAGE_UTILIZED'
export const LOGIN_USER = 'LOGIN_USER'
export const SOCIAL_LOGIN = 'SOCIAL_LOGIN'
export const LOGOUT_USER = 'LOGOUT_USER'
export const GET_USER_PROFILE = 'GET_USER_PROFILE'
export const RESTORE_SESSION = 'RESTORE_SESSION'
export const REGISTER_USER = 'REGISTER_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const SET_LOGGED_IN_USER = 'SET_LOGGED_IN_USER'
export const UPDATE_MEMBERSHIP = 'UPDATE_MEMBERSHIP'
export const SET_USER_LOGOUT = 'SET_USER_LOGOUT'
export const GET_FCM_TOKEN = 'GET_FCM_TOKEN'
export const SET_FCM_TOKEN = 'SET_FCM_TOKEN'
export const SET_FCM_LOADED = 'SET_FCM_LOADED'
export const UPDATE_NOTIFICATION_SETTINGS = 'UPDATE_NOTIFICATION_SETTINGS'
export const UPDATE_EXTENSION_SETTINGS = 'UPDATE_EXTENSION_SETTINGS'
export const SETUP_FCM = 'SETUP_FCM'
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
export const TOGGLE_MAINMENU = 'TOGGLE_MAINMENU'
export const TOGGLE_INVITE_TEAMMATES = 'TOGGLE_INVITE_TEAMMATES'
export const GET_CHANGELOGS = 'GET_CHANGELOGS'
export const SET_CHANGELOGS = 'SET_CHANGELOGS'
export const GET_TOTALITEMS = 'GET_TOTALITEMS'
export const SET_TOTALITEMS = 'SET_TOTALITEMS'
export const SET_IS_EDITING_CONTENT = 'SET_IS_EDITING_CONTENT'

export const SET_IS_RESPONSE_DROPDOWN_VISIBLE = 'SET_IS_RESPONSE_DROPDOWN_VISIBLE'
export const SET_RESPONSE_DROPDOWN_POSITION = 'SET_RESPONSE_DROPDOWN_POSITION'
export const SET_CURRENT_RESPONSE_DROPDOWN = 'SET_CURRENT_RESPONSE_DROPDOWN'
export const SET_IS_COPYING_LOADING = 'SET_IS_COPYING_LOADING'
export const SET_DROPDOWN_DIRECTION = 'SET_DROPDOWN_DIRECTION'

export const SET_IS_PAGE_DROPDOWN_VISIBLE = 'SET_IS_PAGE_DROPDOWN_VISIBLE'
export const SET_PAGE_DROPDOWN_POSITION = 'SET_PAGE_DROPDOWN_POSITION'
export const SET_CURRENT_PAGE_DROPDOWN = 'SET_CURRENT_PAGE_DROPDOWN'

export const SAVE_ICON_COVER_IMAGE = 'SAVE_ICON_COVER_IMAGE'
export const DELETE_ICON_COVER_IMAGE = 'ICON_ICON_COVER_IMAGE'
export const REPOSITION_COVER_IMAGE = 'REPOSITION_COVER_IMAGE'

export const SET_IS_REQUEST_CALL_COMPLETE = 'SET_IS_REQUEST_CALL_COMPLETE'
export const SET_ERROR_BAG = 'SET_ERROR_BAG'

export const SET_FULLSCREEN_STATUS = 'SET_FULLSCREEN_STATUS'

export const SET_SELECTED_PAGE_OR_DRAFT = 'SET_SELECTED_PAGE_OR_DRAFT'